/**
 * V70.7: 연장/휴일근무 승인 요청의 프로젝트 표시 라벨
 *
 * 승인 관리(WorkApprovalsPage)와 내 신청(WorkMyApprovalsPage)이 동일 규칙을 사용한다.
 * BE functions/src/modules/approval/queries.ts getProjectLabel(검색 매칭)과 동일 규칙.
 *
 * 저장 구조 (V121 createOvertimeRequest):
 * - requestData.projectId: 프로젝트 문서 ID 또는 'NON_PROJECT'(공통업무)
 * - projectName: 조회 callable 이 응답에만 붙이는 값 (string | null=삭제된 프로젝트)
 *
 * 표시 규칙:
 * - NON_PROJECT                      → '공통업무'
 * - projectId + projectName(문자열)   → projectName
 * - projectId + projectName === null → '삭제된 프로젝트'
 * - 그 외(projectId 없음 / 이름 미확인) → '-'  (raw projectId 는 노출하지 않음)
 */

const PROJECT_SELECTABLE_TYPES: ReadonlySet<string> = new Set(['overtime', 'weekendWork', 'holidayWork']);

/** V121: 공통업무(비프로젝트) sentinel */
const NON_PROJECT_ID = 'NON_PROJECT';

export function isProjectSelectableApprovalType(type: string): boolean {
  return PROJECT_SELECTABLE_TYPES.has(type);
}

export function getApprovalProjectLabel(requestData: any, projectName?: string | null): string {
  const projectId = requestData?.projectId;
  if (!projectId) return '-';
  if (projectId === NON_PROJECT_ID) return '공통업무';
  if (projectName === null) return '삭제된 프로젝트';
  return projectName || '-';
}

/**
 * 목록 "내용" 앞에 [프로젝트] 표시 (대상 타입만, 라벨이 '-' 이면 기존 내용 그대로)
 */
export function withApprovalProjectPrefix(
  type: string,
  requestData: any,
  projectName: string | null | undefined,
  content: string,
): string {
  if (!isProjectSelectableApprovalType(type)) return content;
  const label = getApprovalProjectLabel(requestData, projectName);
  if (label === '-') return content;
  return content && content !== '-' ? `[${label}] ${content}` : `[${label}]`;
}
